import { render, staticRenderFns } from "./SurveyAdminList.vue?vue&type=template&id=ff12c8d0&scoped=true&"
import script from "./SurveyAdminList.vue?vue&type=script&lang=js&"
export * from "./SurveyAdminList.vue?vue&type=script&lang=js&"
import style0 from "./SurveyAdminList.vue?vue&type=style&index=0&id=ff12c8d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff12c8d0",
  null
  
)

export default component.exports